import axiosWrapper from './axiosWrapper';

/**
 * Game design data (ERD, type chart, formulas) for video game projects.
 */
const gameDesignService = {
  async getGameDesign(projectId) {
    return axiosWrapper({
      method: 'get',
      path: `projects/${projectId}/gamedesign`,
    });
  },

  /**
   * Update one or more sections.
   * @param {string} projectId
   * @param {Object} updates - any of { entities, relations, typeChart, formulas }
   */
  async updateGameDesign(projectId, updates) {
    return axiosWrapper({
      method: 'put',
      path: `projects/${projectId}/gamedesign`,
      data: updates,
      optimistic: false,
    });
  },
};

export default gameDesignService;
